import { Typography } from "@mui/material";

import { UnknownSecurities } from "../../../Type";

export default function Entity({ connectedEntity }: UnknownSecurities) {
	return (
		<Typography variant='subtitle2' textTransform={"capitalize"}>
			{connectedEntity}
		</Typography>
	);
}
